module.exports = __webpack_public_path__ + "static/media/favicon.df7aae99.png";